/**
 * Helpers de CIDR IPv4 no front.
 *
 * Usado para confrontar os IPs que o device reporta na telemetria com as redes já declaradas
 * como "do lado do device" (remote_networks). Um IP local não coberto por nenhuma dessas redes
 * fica fora das AllowedIPs do peer no servidor VPN — e o retorno do host por esse IP é
 * descartado pelo crypto-key routing, quebrando a conexão só num sentido.
 */

/** Converte "10.50.0.18" em inteiro sem sinal. Retorna null se não for IPv4 válido. */
export function ipv4ToUint(ip) {
  if (typeof ip !== 'string') return null
  const parts = ip.trim().split('.')
  if (parts.length !== 4) return null
  let value = 0
  for (const part of parts) {
    if (!/^\d{1,3}$/.test(part)) return null
    const octet = Number(part)
    if (octet > 255) return null
    value = (value * 256) + octet
  }
  return value >>> 0
}

/** Separa "10.50.0.18/27" em { ip, prefix }. Sem barra, assume /32. */
export function parseCidr(cidr) {
  if (typeof cidr !== 'string') return null
  const [ip, rawPrefix] = cidr.trim().split('/')
  const value = ipv4ToUint(ip)
  if (value === null) return null
  const prefix = rawPrefix === undefined ? 32 : Number(rawPrefix)
  if (!Number.isInteger(prefix) || prefix < 0 || prefix > 32) return null
  return { ip, value, prefix }
}

/** true se o IP (ou o endereço de um CIDR) cai dentro da rede informada. */
export function cidrContains(networkCidr, ipOrCidr) {
  const network = parseCidr(networkCidr)
  const target = parseCidr(ipOrCidr)
  if (!network || !target) return false
  if (network.prefix === 0) return true
  const mask = (0xffffffff << (32 - network.prefix)) >>> 0
  return ((network.value & mask) >>> 0) === ((target.value & mask) >>> 0)
}
